import { isIosNativeAppRuntime } from './runtimeCapabilities';

const IOS_REVIEW_RESTRICTED_HAZARD_TYPES = new Set<string>([
  'cop',
  'safety_inspector',
  'dot_officer',
]);

const IOS_REVIEW_RESTRICTED_FAB_IDS = new Set<string>([
  'copAlert',
  'safetyShield',
  'safetyGuy',
  'dot',
  'copReport',
  // foodTrucks stays restricted (legacy cash/card hub). deliveryServices is
  // allowed: physical goods / real-world services modal (water, tacos, hotshot, WM).
  'foodTrucks',
  'ziaGivesBack',
]);

export function isIosAppReviewRuntime(): boolean {
  return isIosNativeAppRuntime();
}

export function canShowNonApplePaymentSurface(): boolean {
  return false;
}

export function canShowLicenseKeyClaimSurface(): boolean {
  return false;
}

export function isIosReviewRestrictedHazardType(type?: string | null): boolean {
  return IOS_REVIEW_RESTRICTED_HAZARD_TYPES.has(String(type || ''));
}

export function isIosReviewRestrictedFabId(fabId?: string | null): boolean {
  return IOS_REVIEW_RESTRICTED_FAB_IDS.has(String(fabId || ''));
}

export function filterIosReviewRestrictedHazards<T extends { type?: string | null }>(items: T[]): T[] {
  return items.filter((item) => !IOS_REVIEW_RESTRICTED_HAZARD_TYPES.has(String(item.type || '')));
}
